import { SessionResponse, type SessionSummary } from '@diana/contracts';
import { useQueries } from '@tanstack/react-query';

import { useAdminApi } from '../../app/AdminApiContext.js';

/** Optional real notes stay out of the strict summary and mutable editor caches. */
export function useRequestNotes(shoots: readonly SessionSummary[]) {
  const api = useAdminApi();
  const requests = shoots.filter((shoot) => shoot.status === 'NewRequest');
  const queries = useQueries({
    queries: requests.map((shoot) => ({
      queryKey: ['crm-request-notes', shoot.id, shoot.revision],
      queryFn: async () =>
        (await api.get(`/api/v1/admin/sessions/${shoot.id}`, SessionResponse)).session.notes,
      staleTime: 30_000,
      refetchOnMount: 'always' as const,
      retry: false,
    })),
  });
  return Object.fromEntries(
    requests.map((shoot, index) => [
      shoot.id,
      queries[index]?.isError ? undefined : queries[index]?.data,
    ]),
  );
}
